<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('nozzle_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-nozzle-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'Nozzle';

export default {
  name: 'NozzleShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('nozzle', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('nozzle', ['find'])
  },
  methods: {
    ...mapActions('nozzle', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
